<template>
    <div class="flex flex-col">
        <div class="flex items-center mb-4" v-if="showName">
            <div @click="onPlayerNameClicked(playerIndex)"
                class="min-w-12 text-base font-medium text-gray-800 cursor-pointer hover:text-primary transition-colors">
                {{ name }}
            </div>
            <b class="w-6 text-lg font-bold text-success">{{ totalScore }}</b>
        </div>
        <div class="flex items-center">
            <div v-for="(roundScore, index) in playerScore.roundScores" :key="index">
                <v-round-score @click="onRoundScoreClicked(roundScore, index, playerIndex)" :round-score="roundScore"
                    @score-click="OnScoreClicked" :index="index" :is-old-score="playerScore.isOldScore"
                    :show-replay="showReplay"></v-round-score>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import vRoundScore from './RoundScore.vue';

const props = defineProps({
    playerScore: {
        type: Object,
        default: () => ({
            name: '',
            totalScore: 0,
            roundScores: [],
            isOldScore: false,
            replayInfos: [] // 如果replayInfos是playerScore的一部分，则也应该包括它
        })
    },
    playerIndex: {
        type: Number,
        default: 0
    },
    showName: {
        type: Boolean,
        default: true
    },
    showReplay: {
        type: Boolean,
        default: true
    }
});

const emit = defineEmits(['round-click', 'name-click', 'score-click']); // 显式定义emit
const name = computed(() => props.playerScore.name);
const totalScore = computed(() => props.playerScore.totalScore);
const roundScores = computed(() => props.playerScore.roundScores);

const onRoundScoreClicked = (roundScore, index, playerIndex) => {
    emit('round-click', roundScore, index, playerIndex);
};

const OnScoreClicked = (roundIndex, scoreIndex) => {
    emit('score-click', props.playerIndex, roundIndex, scoreIndex);
};

const onPlayerNameClicked = (playerIndex) => {
    emit('name-click', playerIndex);
};
</script>

<style scoped>
/* 所有样式已通过 Tailwind 类实现 */
</style>